(() => {
  if (window.pushpauraCartDrawerEnhancementsLoaded) return;
  window.pushpauraCartDrawerEnhancementsLoaded = true;

  const wait = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));
  const cartUrl = () => window.routes?.cart_url || '/cart';

  const setMessage = (element, message, isError = false) => {
    if (!element) return;
    element.textContent = message;
    element.classList.toggle('is-error', isError);
  };

  const refreshCartDrawer = async () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const response = await fetch(`${cartUrl()}?sections=cart-drawer,cart-icon-bubble`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error('Unable to refresh cart');
    const sections = await response.json();
    if (sections['cart-drawer']) drawer.renderContents({ sections });
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cart-discount-form]');
    if (!form) return;
    event.preventDefault();

    const input = form.querySelector('[name="discount"]');
    const button = form.querySelector('button[type="submit"]');
    const message = form.querySelector('[data-cart-discount-message]');
    const code = input?.value.trim();
    if (!code) {
      setMessage(message, 'Enter a discount code to apply.', true);
      input?.focus();
      return;
    }

    button.disabled = true;
    setMessage(message, 'Applying code…');
    try {
      const updateUrl = `${cartUrl().replace(/\/$/, '')}/update.js`;
      const applyResponse = await fetch(updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ discount: code }),
      });
      const cart = await applyResponse.json();
      if (!applyResponse.ok) {
        throw new Error(cart.description || cart.message || 'Discount code could not be applied.');
      }
      await refreshCartDrawer();
      const refreshedMessage = document.querySelector('[data-cart-discount-message]');
      setMessage(refreshedMessage, 'Discount code added. Shopify will confirm eligibility and savings at checkout.');
    } catch (error) {
      setMessage(document.querySelector('[data-cart-discount-message]'), error.message || 'We could not apply that code. Please try again.', true);
    } finally {
      const refreshedButton = document.querySelector('[data-cart-discount-form] button[type="submit"]');
      if (refreshedButton) refreshedButton.disabled = false;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cart-shipping-form]');
    if (!form) return;
    event.preventDefault();

    const message = form.querySelector('[data-cart-shipping-message]');
    const resultsList = form.querySelector('[data-cart-shipping-results]');
    const button = form.querySelector('button[type="submit"]');
    const values = new FormData(form);
    const country = String(values.get('country') || '').trim();
    const province = String(values.get('province') || '').trim();
    const zip = String(values.get('zip') || '').trim();

    if (!country || !zip) {
      setMessage(message, 'Enter a country/region and postal code.', true);
      return;
    }

    const params = new URLSearchParams();
    params.set('shipping_address[country]', country);
    params.set('shipping_address[zip]', zip);
    if (province) params.set('shipping_address[province]', province);

    button.disabled = true;
    resultsList.replaceChildren();
    setMessage(message, 'Calculating available rates…');

    try {
      const prepareUrl = `${cartUrl()}/prepare_shipping_rates.json?${params.toString()}`;
      const prepareResponse = await fetch(prepareUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!prepareResponse.ok) throw new Error('Shipping rates could not be prepared');

      let shippingRates = null;
      for (let attempt = 0; attempt < 8; attempt += 1) {
        await wait(500);
        const rateResponse = await fetch(`${cartUrl()}/async_shipping_rates.json?${params.toString()}`, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        });
        if (!rateResponse.ok) throw new Error('Shipping rates could not be loaded');
        const rateData = await rateResponse.json();
        if (Array.isArray(rateData?.shipping_rates)) {
          shippingRates = rateData.shipping_rates;
          break;
        }
        if (rateData?.errors) throw new Error('No shipping rates are available for that address');
      }

      if (!shippingRates) throw new Error('Shipping rates are taking longer than expected. Try again shortly.');
      if (shippingRates.length === 0) throw new Error('No shipping rates are available for that address.');

      const currency = window.Shopify?.currency?.active || 'INR';
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency',
        currency,
      });
      shippingRates.forEach((rate) => {
        const item = document.createElement('li');
        const name = document.createElement('span');
        const price = document.createElement('strong');
        name.textContent = rate.presentment_name || rate.name;
        price.textContent = formatter.format(Number(rate.price));
        item.append(name, price);
        resultsList.append(item);
      });
      setMessage(message, 'Estimated rates for this address:');
    } catch (error) {
      setMessage(message, error.message || 'Shipping rates could not be calculated.', true);
    } finally {
      button.disabled = false;
    }
  });
})();
